import React from 'react';
import { GameState } from '../types/game';
import { Button } from './ui/Button';
import { Card } from './ui/Card';
import { TrophyIcon, Share2Icon, RefreshCwIcon } from 'lucide-react';
interface WinStateProps {
  gameState: GameState;
  onReset: () => void;
}
export function WinState({
  gameState,
  onReset
}: WinStateProps) {
  const formatMoney = (val: number) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits: 0
    }).format(val);
  };
  return <div className="fixed inset-0 z-50 flex items-center justify-center bg-background/95 backdrop-blur-sm p-4" data-id="element-375">
      <Card className="w-full max-w-2xl border-primary shadow-glow-teal-lg animate-slide-up" data-id="element-376">
        <div className="text-center mb-8" data-id="element-377">
          <div className="w-20 h-20 bg-primary/20 text-primary rounded-full flex items-center justify-center mx-auto mb-6 shadow-glow-teal" data-id="element-378">
            <TrophyIcon className="w-10 h-10" data-id="element-379" />
          </div>
          <h1 className="text-4xl font-bold text-text-primary mb-2" data-id="element-380">
            Successful Orbit
          </h1>
          <p className="text-xl text-text-secondary" data-id="element-381">
            You survived 10 years and built a sustainable business.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8" data-id="element-382">
          <div className="bg-surface-highlight p-6 rounded-lg text-center border border-border hover:border-success/30 transition-colors" data-id="element-383">
            <div className="text-xs text-text-secondary uppercase tracking-wider mb-2" data-id="element-384">
              Final Cash
            </div>
            <div className="text-2xl font-mono font-bold text-success" data-id="element-385">
              {formatMoney(gameState.cash)}
            </div>
          </div>
          <div className="bg-surface-highlight p-6 rounded-lg text-center border border-border hover:border-primary/30 transition-colors" data-id="element-386">
            <div className="text-xs text-text-secondary uppercase tracking-wider mb-2" data-id="element-387">
              Total Revenue
            </div>
            <div className="text-2xl font-mono font-bold text-primary" data-id="element-388">
              {formatMoney(gameState.history.reduce((acc, curr) => acc + curr.revenue, 0))}
            </div>
          </div>
          <div className="bg-surface-highlight p-6 rounded-lg text-center border border-border hover:border-primary/30 transition-colors" data-id="element-389">
            <div className="text-xs text-text-secondary uppercase tracking-wider mb-2" data-id="element-390">
              Peak Headcount
            </div>
            <div className="text-2xl font-mono font-bold text-text-primary" data-id="element-391">
              {Math.max(...gameState.history.map(h => h.headcount))}
            </div>
          </div>
        </div>

        <div className="flex justify-center space-x-4" data-id="element-392">
          <Button onClick={onReset} size="lg" variant="secondary" data-id="element-393">
            <RefreshCwIcon className="w-4 h-4 mr-2" data-id="element-394" />
            New Game
          </Button>
          <Button size="lg" data-id="element-395">
            <Share2Icon className="w-4 h-4 mr-2" data-id="element-396" />
            Share Score
          </Button>
        </div>
      </Card>
    </div>;
}